import React, { useState } from "react";

const handleUpdate = (e, value, field, update, format) => {
  const text = format ? format(e.target.value) : e.target.value;
  if (!field) {
    update(text);
  } else {
    const newValue = { ...value };
    newValue[field] = text;
    update(newValue);
  }
};

export default function TextField({
  label,
  placeholder,
  type,
  value,
  field,
  update,
  format,
  errors,
  Icon,
  iconClassName = "",
  ActionIcon,
  className = "",
  ...props
}) {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div className="relative">
      {label && <label className="font-bold text-secondary">{label}</label>}
      <div
        className={`flex my-1 border-2 w-full h-12 ${
          isFocused ? "border-secondary" : "border-secondary/50"
        } ${className}`}
      >
        {Icon ? (
          <div className="flex items-center justify-center shrink-0 w-12 bg-white/20">
            <Icon
              className={`${
                isFocused ? "fill-primary" : "fill-primary/50"
              } ${iconClassName}`}
              width={16}
            />
          </div>
        ) : null}
        <input
          type={type}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          value={
            !!field
              ? !!value && !!value[field]
                ? value[field]
                : ""
              : !!value
              ? value
              : ""
          }
          onChange={(e) => handleUpdate(e, value, field, update, format)}
          className="border-none focus:outline-0 w-full h-full px-3 text-white bg-transparent"
          placeholder={placeholder ? placeholder : label}
          {...props}
        />
        {ActionIcon ? (
          <div className="flex items-center justify-center w-12 bg-transparent pr-1">
            <ActionIcon />
          </div>
        ) : null}
      </div>
      {errors && errors[field] ? (
        <div className="absolute right-1.5 bottom-[-10px] px-2 bg-validation text-danger rounded-sm">
          {errors[field]}
        </div>
      ) : null}
    </div>
  );
}
